import script from "./OldSqmComplaintDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OldSqmComplaintDetails.vue?vue&type=script&setup=true&lang=js"

import "./OldSqmComplaintDetails.vue?vue&type=style&index=0&id=f37d7efe&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f37d7efe"]])

export default __exports__